import React, { useEffect, useState } from "react";
import contactImg from "../img/contact_form.jpg";
import "../css/home.css";

function Contact() {
  // Form state
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    query: "",
  });

  const [responseMsg, setResponseMsg] = useState("");

  // Intersection Observer for fade-up animation
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("show");
        });
      },
      { threshold: 0.3 }
    );

    const elements = document.querySelectorAll(".fade-up");
    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  // Handle form input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch("https://neatnesthub.com/submit_contact.php", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData).toString(),
      });

      const data = await res.json();
      setResponseMsg(data.message);

      if (data.status === "success") {
        // Reset form
        setFormData({ name: "", email: "", phone: "", query: "" });
      }
    } catch (err) {
      setResponseMsg("An error occurred. Please try again.");
      console.error(err);
    }
  };

  return (
    <div className="contact-section py-5">
      <div className="container">
        <div className="row align-items-center">

          {/* Left Column: Contact Form */}
          <div className="col-lg-6 mb-4">
            <div className="contact-card p-4 shadow-lg rounded fade-up">
              <h2 className="mb-4 text-primary">Get in Touch</h2>
              <p className="mb-4 text-muted">
                We'd love to hear from you! Fill out the form and we'll get back to you soon.
              </p>

       

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="form-control shadow-sm"
                    placeholder="Your Name"
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="form-control shadow-sm"
                    placeholder="Your Email"
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Phone Number</label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="form-control shadow-sm"
                    placeholder="Your Phone Number"
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Your Query</label>
                  <textarea
                    name="query"
                    value={formData.query}
                    onChange={handleChange}
                    className="form-control shadow-sm"
                    rows="4"
                    placeholder="Type your message"
                    required
                  ></textarea>
                </div>

                <button type="submit" className="btn btn-primary btn-hover">
                  Submit
                </button>
              </form>
<br />
                     {/* Response Message */}
              {responseMsg && <div className="alert alert-info">{responseMsg}</div>}
            </div>
          </div>

          {/* Right Column: Image */}
          <div className="col-lg-6 fade-up">
            <div className="contact-image overflow-hidden rounded shadow">
              <img
                src={contactImg}
                alt="Contact Us"
                className="img-fluid"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default Contact;
